/**
 * Typed Redux hooks.
 *
 * Always use these rather than the untyped `useDispatch` and `useSelector`:
 * the untyped selector hands you `unknown` state, and the untyped dispatch
 * cannot type-check a thunk.
 */

import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch, RootState } from "./index";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

/** The signed-in account, or null. */
export const useCurrentUser = () => useAppSelector((s) => s.auth.user);

/** Whether there is a session at all. Does not prove the token is still valid. */
export const useIsAuthenticated = () =>
    useAppSelector((s) => Boolean(s.auth.accessToken));
